/* eslint-disable import/no-anonymous-default-export */
import siteConfig, { formatMoney } from "../siteConfig";

export default {
  path: "/faq",
  shortTitle: "FAQ",
  title: "Frequently asked questions",
  category: "Help",
  summary: "Short answers grounded in the current catalog, checkout and support flow.",
  updated: "5 November 2026",
  sections: [
    {
      heading: "What currency and delivery charge apply?",
      body: [
        `All prices are ${siteConfig.currency}. Checkout adds a fixed ${formatMoney(siteConfig.shippingFee)} delivery charge to the merchandise subtotal. The country selector shows the destinations currently offered by the storefront.`,
      ],
    },
    {
      heading: "Which carrier is used and how long does delivery take?",
      body: [
        `Orders dispatch from the ${siteConfig.fulfilment.origin} within ${siteConfig.fulfilment.dispatchTime}. Hong Kong orders use ${siteConfig.fulfilment.carriers.domestic}; overseas orders use ${siteConfig.fulfilment.carriers.regional} or ${siteConfig.fulfilment.carriers.international}.`,
        `The normal end-to-end estimate is ${siteConfig.fulfilment.totalEstimates.domestic} for Hong Kong, ${siteConfig.fulfilment.totalEstimates.regional} for the listed regional destinations, and ${siteConfig.fulfilment.totalEstimates.international} for the other checkout destinations. Tracking is emailed after dispatch.`,
      ],
    },
    {
      heading: "Where do I enter card details?",
      body: [
        `Never in the ${siteConfig.brandName} React form or by email. Pay Now opens a hosted checkout created through the same-origin PHP endpoint. A success return page is not proof that settlement completed; ${siteConfig.brandName} verifies payment separately before acceptance.`,
      ],
    },
    {
      heading: "Will my handmade item match exactly?",
      body: [
        "The product type, principal material, size and ordered colour should match the listing. Reactive glaze, throwing lines, fibre tone, weave and velvet direction can vary within the disclosed characteristics. Read the Product Accuracy policy and both product photographs.",
      ],
    },
    {
      heading: "How do I change, return or report an order?",
      body: [
        "Email the order number and details before sending anything. An authorised Hong Kong return address is provided after the request is approved. Keep packaging for damage claims, and consult the Cancellation, Returns and Parcel Problems policies for the relevant process.",
      ],
    },
    {
      heading: "What is not sold or offered?",
      body: [
        "There are no gift cards, preorders, subscriptions, digital downloads, mystery boxes, wholesale accounts, click-and-collect, loyalty or referral programme, or repair and warranty registration in the current project. The catalog does contain one workshop request item, which requires separate confirmation.",
      ],
    },
  ],
};
